import { ModelBase } from 'store/model-base';

import { ProgressStatus } from 'my-account/constants';

export class RequestResult extends ModelBase {
    public static storeName: string = 'requestResult';

    public requestStatus: ProgressStatus;
}
